module.exports = __webpack_public_path__ + "static/img/flut.b0f750a4.png";